import React from 'react';
import { IonRow, IonCol, IonIcon } from '@ionic/react';
import './Dashboard.scss';
import { getSkinUrl } from '../../util/urlUtils';
import { capitalize, getLogo, getSubDomain } from '../../util/stringUtil';

const ThemeChangesPage = (props) => {
  const { skins } = props;

  return (
    <>
      <div className="reports-ctn my-wallet-ctn mob-view">
        <div className="carw mob-view">
          <div className="arrow arrow-right">
            <div className="name">Change Site</div>
          </div>
        </div>

        <div className="dashboard-ctn">
          <IonRow className="dashboard-cards-ctn">
            {skins?.length &&
              skins.map((skin, idx) => {
                return skin ? (
                  <IonCol
                    className="dashboard-item"
                    sizeXs="12"
                    sizeSm="12"
                    sizeMd="12"
                  >
                    <div
                      className="dashboard-item-link"
                      onClick={() =>
                        window.open(
                          `https://${getSkinUrl(
                            getSubDomain(skin.toLowerCase())
                          )}/login?authToken=${sessionStorage.getItem('jwt_token')}`,
                          '_self'
                        )
                      }
                    >
                      <div className="ion-ctn">
                        <IonIcon
                          className={'dashboard-item-icon'}
                          color="primary"
                          src={getLogo(skin)}
                        />
                      </div>
                      <span className="dashboard-item-text">{capitalize(skin)}</span>
                    </div>
                  </IonCol>
                ) : null;
              })}
          </IonRow>
        </div>
      </div>
    </>
  );
};

export default ThemeChangesPage;
